import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SignupVerifyFormComponent } from '../../ui/signup-verify-form/signup-verify-form.component';
import { SignUpService } from '../../data-access/signup.service';
import { Subject, takeUntil } from 'rxjs';
import { CommunicationType } from '../../interfaces/signUp.interface';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'equine-ui-nx-signup-verify',
  standalone: true,
  imports: [CommonModule, SignupVerifyFormComponent],
  templateUrl: './signup-verify.component.html',
  styleUrl: './signup-verify.component.scss',
})
export class SignupVerifyComponent implements OnInit, OnDestroy{

  isVerified: boolean = false;
  email: any;
  loading: boolean = false;
  unsubscribe$ = new Subject<void>();
  resendDisabled: boolean = false;
  subject = new Subject<void>();
  resendTime = 60 * 1000;
  errorCode: string = '';
  errorCodes: string[] = [
    'InvalidVerificaitonCode',
    'ReachedMaxAttempt',
    'ExpiredVerificationCode'
  ];
  subscription
  queryParams:any
  appName!: string;
  constructor(
    private signUpService: SignUpService,
    private snackBar: MatSnackBar,
    private router: Router,
    private activatedRoute: ActivatedRoute,
  ){
    this.subscription = this.activatedRoute.queryParams.subscribe(
      (params: any) => {
        this.queryParams = JSON.parse(JSON.stringify(params));
        if(this.queryParams?.receiver){
          this.email = this.queryParams.receiver;
          if (this.queryParams?.otp) {
            this.verify(this.queryParams?.otp);
          }
          if(this.queryParams?.resend == "yes"){
            this.resend()
          }
        }
      }
    );
  }


  ngOnInit(): void {
    this.email = localStorage.getItem('signup-email');
    if(!this.email) {
      this.errorEmailNotFoundHandle();
    }
    this.activatedRoute.data.pipe(takeUntil(this.unsubscribe$))
    .subscribe((data: any)=>{
      this.appName = data.appName;
    })
  }

  resend() {
    if(!this.resendDisabled && this.email) {
    // if( this.email) {
      // this.resendTime *= 2;
      // this.disableTimeout();
      this.loading = true;
      this.signUpService
        .generateOtp(CommunicationType.EMAIL, this.email, 'ReVerify', this.appName)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe({
          next: (data)=> {
            if(data.status) {
              this.disableTimeout();
              this.snackBar.open(`Success: Sent Otp again on ${this.email}`,'Dismiss', {duration: 3000, panelClass:['success-snackbar']});
            } else {
              const errorMessage = data?.message ? data.message : 'Unable to send Email';
              this.snackBar.open(`Error: ${errorMessage}`,'Dismiss', {duration: 3000, panelClass:['error-snackbar']});
            }
            this.loading = false;
          },
          error: (err)=> {
            this.loading = false;
            const errorMessage = Array.isArray(err?.error?.message) ? err.error.message[0] : err?.error?.message;
            this.showError(errorMessage);
          }
        })
    }
     else if(this.resendDisabled) {
      this.snackBar.open(`Error: This option will enable everytime after 60 seconds`,'Dismiss', { duration: 5000, panelClass:['error-snackbar']});
    } 
    else {
      this.errorEmailNotFoundHandle();
    }
  }

  disableTimeout() {
    this.resendDisabled = true;
    setTimeout(()=> {
      this.resendDisabled = false;
    }, this.resendTime);
  }

  verify(otp: string) {
    if(this.email && !this.loading) {
      this.loading = true;
      this.errorCode = '';
      this.signUpService
        .verifyOtp(CommunicationType.EMAIL, this.email, otp, this.appName)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe({
          next: (data)=> {
            if(data.status) {
              this.isVerified = true;
              this.router.navigate(['account','verify-success']);
            } else {
              const errorMessage = data?.message ? data.message : 'Unable to Verify';
              if(this.errorCodes.includes(errorMessage)) {
                this.errorCode = errorMessage;
              } else {
                this.snackBar.open(`Error: ${errorMessage}`,'Dismiss', {duration: 3000, panelClass:['error-snackbar']});
              }
            }
            this.loading = false;
          },
          error: (err)=> {
            this.loading = false;
            const errorMessage = Array.isArray(err?.error?.message) ? err.error.message[0] : err?.error?.message;
            this.showError(errorMessage);
          }
        })
    } else {
      this.errorEmailNotFoundHandle();
    }
  }

  showError(errorMsg: string) {
    if(!errorMsg) {
      errorMsg = 'Internal Server error';
    }
    this.snackBar.open(`Error: ${errorMsg}`, 'close', { duration: 5000, panelClass:['error-snackbar']});
  }

  errorEmailNotFoundHandle() {
    this.snackBar.open(`Error: Connot process this request`,'Dismiss', { duration: 5000, panelClass:['error-snackbar']});
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
    this.subject.next();
    this.subject.complete();
  }
}
